module.exports = __webpack_public_path__ + "img/mastercard.9fa8b14.svg";